import React, { useState, useEffect } from 'react'
import { Container, Form, Button, Row, Col } from 'react-bootstrap';
import {  useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { useProfileTeacherMutation } from '../../slices/teachers/teachersApiSlice';
import { setTeacherCredentials } from '../../slices/teachers/authTeacherSlice';
import { toast } from 'react-toastify';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import TeacherHeader from '../../components/TeacherHeader';
import TeacherNavbar from '../../components/TeacherNavbar';

const TeacherProfile = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [jobtitle, setJobtitle] = useState('');
  const [about, setAbout] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [birthdate, setBirthdate] = useState('');
  const [country, setCountry] = useState('');
  const [city, setCity] = useState('');
  const [zipcode, setZipcode] = useState('');

  const [isvideo, setIsvideo] = useState(false); 
  const [videoFile, setVideoFile] = useState(null); 

  const { teacherInfo } = useSelector((state) => state.authTeacher);

  const [updateProfileTeacher, { isLoading: loadingUpdateProfileTeacher }] = useProfileTeacherMutation();

  useEffect(() => {
    if(!teacherInfo) {
        navigate('/teacherlogin')
    }
  }, [navigate, teacherInfo]);

  useEffect(() => {
    setFirstname(teacherInfo?.firstname);
    setLastname(teacherInfo?.lastname);
    setJobtitle(teacherInfo?.jobtitle);
    setAbout(teacherInfo?.about);
    setEmail(teacherInfo?.email);
    setBirthdate(teacherInfo?.birthdate);
    setCountry(teacherInfo?.country);
    setCity(teacherInfo?.city);
    setZipcode(teacherInfo?.zipcode);


  }, [teacherInfo?.firstname, teacherInfo?.lastname, teacherInfo?.email, teacherInfo?.jobtitle, teacherInfo?.about, teacherInfo?.birthdate, teacherInfo?.country, teacherInfo?.city]);
     

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.type == 'image/png' ||  file.type == 'image/jpeg' || file.type == 'image/jpg') { 
        setIsvideo(true); 
        setVideoFile(event.target.files[0]); 
      } else {  
        toast.error('Please upload a png or jpeg or jpg image file ');
      }
    } 
  };


  const submitHandler = async (e) => {
    e.preventDefault()
    if (firstname == '') { toast.error('Please enter first name'); return; } 
    if (lastname == '') { toast.error('Please enter  last name'); return; } 
    if (email == '') { toast.error('Please enter  email'); return; } 
    if (jobtitle == '') { toast.error('Please enter  job title'); return; } 
    if (about == '') { toast.error('Please enter about  me'); return; } 

    if (birthdate == '') { toast.error('Please enter  birthdate'); return; }
    if (country == '') { toast.error('Please enter  country'); return; }
    if (city == '') { toast.error('Please enter  city'); return; }
    if (zipcode == '') { toast.error('Please enter  zip code'); return; }

    // if (videoFile == null) { toast.error('Please upload a picture for your public profile'); return; }

    if (password !== confirmPassword) {
      toast.error('Passwords do not match');
    }
    else {
      try {
        const res = await updateProfileTeacher({ firstname, lastname, jobtitle, about, email, password, birthdate, country, city, zipcode   }).unwrap();
        dispatch(setTeacherCredentials({ ...res }));
        if (isvideo) {
          var fd = new FormData();
          fd.append('upl', videoFile);
          fetch('/api/upload/uploadteacherimage',
        {
            method: 'post',
            body: fd,
          })
          .then(response => response.json())
          .then(data => {
            toast.success('picture Saved');
          })
          .catch(error => {
            toast.success('Error uploading picture');
          });
        } else {  
          toast.error('Please upload a picture for your public profile');  
        }
        toast.success('Profile Updated');
      } catch (err) {
        toast.error(err?.data?.message || err.error.message);
      }
    };
  };

  return (
    <div>
    <TeacherNavbar />
      <div className="main-content" id="panel">
      <TeacherHeader /><br /><br /><br /><br /><br />
        <div className="container-fluid mt--6">
          <div className="row">
            <div className="col-xl-10 offset-xl-1 newSubj">  
              <div className="card-wrapper profileCard">
                <div className="card"> <br />
                  <h2 className="centerTitle tittleColor4 ">
                  <span className='tittleColor'>
                     Public Profile
                  </span>
                    </h2><br />
                  <div className="card-body">
                    <Form onSubmit={submitHandler}>
                      <div className="form-group">
                        <div className="input-group input-group-merge input-group-alternative mb-3">
                          <div className="input-group-prepend moveInput">
                            <span className="input-group-text bg-gradient-info"><i className="ni ni-tag navText"></i></span>
                          </div>
                          <input 
                            className="form-control" 
                            placeholder="First Name" 
                            value={firstname}
                            style={{textTransform: 'capitalize'}}
                            onChange={(e) => setFirstname(e.target.value)}
                            type="text"                       
                          />
                        </div>
                      </div>
                      <br />
                      <div className="form-group">
                        <div className="input-group input-group-merge input-group-alternative mb-3">
                          <div className="input-group-prepend moveInput">
                            <span className="input-group-text bg-gradient-info"><i className="ni ni-tag navText"></i></span>
                          </div>
                          <input 
                            className="form-control" 
                            placeholder="Last Name" 
                            value={lastname}
                            style={{textTransform: 'capitalize'}}
                            onChange={(e) => setLastname(e.target.value)}
                            type="text"                       
                          />
                        </div>
                      </div>
                      <br />
                      <div className="form-group mb-3">
                        <div className="input-group input-group-merge input-group-alternative">
                          <div className="input-group-prepend moveInput">
                            <span className="input-group-text bg-gradient-danger"><i className="ni ni-email-83 navText"></i></span>
                          </div>
                          <input 
                            className="form-control" 
                            placeholder=" Email" 
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            type="email"                         
                          />
                        </div>
                      </div>
                      <br />
                      <div className="form-group">
                        <div className="input-group input-group-merge input-group-alternative mb-3">
                          <div className="input-group-prepend moveInput">
                            <span className="input-group-text bg-gradient-warning"><i className="ni ni-tag navText"></i></span>
                          </div>
                          <input 
                            className="form-control" 
                            placeholder="Job Title" 
                            value={jobtitle}
                            style={{textTransform: 'capitalize'}}
                            onChange={(e) => setJobtitle(e.target.value)}
                            type="text"                       
                          />
                        </div>
                      </div>
                      <br />
                      <div className="form-group">
                        <div className="input-group input-group-merge input-group-alternative mb-3">
                          <div className="input-group-prepend moveInput">
                            <span className="input-group-text bg-gradient-primary"><i className="ni ni-tag navText"></i></span>
                          </div>
                          <textarea 
                            className="form-control" 
                            placeholder="About me" 
                            rows="6"
                            value={about}
                            onChange={(e) => setAbout(e.target.value)}
                            type="text"                       
                          />
                        </div>
                      </div><br />

                      <div className="form-group">
                        <label for="exampleInputEmail1">Upload a Picture for your public profile </label>
                          <div className="input-group input-group-merge input-group-alternative mb-3">
                            <div className="input-group-prepend moveInput">
                              <span className="input-group-text bg-gradient-info"><i className="ni ni-tag navText"></i></span>
                            </div>                                                
                            <input 
                              id='exampleInputEmail1'
                              type="file" 
                              className="form-control" 
                              onChange={handleFileChange} 
                              />
                          </div>
                      </div><br />

                      
                      <br />
                      <div className="form-group">
                        <div className="input-group input-group-merge input-group-alternative mb-3">
                          <div className="input-group-prepend moveInput">
                            <span className="input-group-text bg-gradient-success"><i className="ni ni-world navText"></i></span>
                          </div>
                          <input 
                            className="form-control" 
                            placeholder="Country" 
                            style={{textTransform: 'capitalize'}}
                            value={country}
                            onChange={(e) => setCountry(e.target.value)}
                            type="text"                       
                          />
                        </div>
                      </div>

                      <br />
                      <div className="form-group">
                        <div className="input-group input-group-merge input-group-alternative mb-3">
                          <div className="input-group-prepend moveInput">
                            <span className="input-group-text bg-gradient-success"><i className="ni ni-pin-3 navText"></i></span>
                          </div>
                          <input 
                            className="form-control" 
                            placeholder="City" 
                            style={{textTransform: 'capitalize'}}
                            value={city}
                            onChange={(e) => setCity(e.target.value)}
                            type="text"                       
                          />
                        </div>
                      </div>

                      <div className="form-group">
                        <div className="input-group input-group-merge input-group-alternative mb-3">
                          <div className="input-group-prepend moveInput">
                            <span className="input-group-text bg-gradient-success"><i className="ni ni-pin-3 navText"></i></span>
                          </div>
                          <input 
                            className="form-control" 
                            placeholder="Zip Code" 
                            style={{textTransform: 'capitalize'}}
                            value={zipcode}
                            onChange={(e) => setZipcode(e.target.value)}
                            type="text"                       
                          />
                        </div>
                      </div>


                      <br />
                      <div className="form-group">
                        <div className="input-group input-group-merge input-group-alternative mb-3">
                          <div className="input-group-prepend moveInput">
                            <span className="input-group-text bg-gradient-primary"><i className="ni ni-paper-diploma navText"></i></span>
                          </div>
                          <input 
                            className="form-control" 
                            placeholder="Date of Birth" 
                            style={{textTransform: 'capitalize'}}
                            value={birthdate}
                            onChange={(e) => setBirthdate(e.target.value)}
                            type="date"                       
                          />
                        </div>
                      </div>



                      <br />
                      <div className="form-group">
                        <div className="input-group input-group-merge input-group-alternative">
                          <div className="input-group-prepend moveInput">
                            <span className="input-group-text bg-gradient-warning"><i className="ni ni-lock-circle-open navText"></i></span>
                          </div>
                          <input 
                            className="form-control" 
                            placeholder=" Password" 
                            type="password"    
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}                      
                          />
                        </div>
                      </div>
                      <br />
                      <div className="form-group">
                        <div className="input-group input-group-merge input-group-alternative">
                          <div className="input-group-prepend moveInput">
                            <span className="input-group-text bg-gradient-warning"><i className="ni ni-lock-circle-open navText"></i></span>
                          </div>
                          <input 
                            className="form-control" 
                            placeholder=" Confirm Password" 
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            type="password"                          
                          />
                        </div>
                      </div><br /><br />
                        <Button type='submit' variant='success' className=' btn btn-primary btn-lg btn-block rounded-pill bg-gradient-info'>
                            Update
                        </Button><br />
                        {loadingUpdateProfileTeacher && <Loader />}
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TeacherProfile